import { memo, ReactNode, useState } from 'react'
import React from 'react'

import { useTheme } from 'styled-components'

import { SwipeableRow } from '@components/SwipeableRow'
import { SapCommentsModal } from '@containers/SapCommentsModal'
import { ChangeStartTimeModal } from '@containers/UpdateTaskModals/ChangeStartTimeModal'
import { useSiteFeatures } from '@hooks/siteFeatures'
import { useStatus } from '@hooks/status'
import { useEditTaskFieldAndTaskList } from '@hooks/task/patch/editFieldAndList'
import { IGenericTask } from '@interfaces/task/generic/IGenericTask'

interface IMidstreamSwipe {
  children: ReactNode
  task: IGenericTask
}

export const MidstreamSwipe = memo(function MidstreamSwipe({
  children,
  task,
}: IMidstreamSwipe) {
  const theme = useTheme()

  const [isChangeStartTimeModalOpen, setIsChangeStartTimeModalOpen] =
    useState(false)
  const [isSapCommentsModalOpen, setIsSapCommentsModalOpen] = useState(false)

  const { getStatusIdByName, getStatusColorById, formatStatus, getStatusList } =
    useStatus()
  const { taskHasCriticality } = useSiteFeatures()

  const { mutateAsync: patchTask } = useEditTaskFieldAndTaskList()

  const isTeco = !!task.sapActionsType

  const hasCriticality = taskHasCriticality(task?.jobAbcIndicator)

  const statusList = getStatusList()
    .map((status) => status.name)
    .filter((status) => status !== 'undefined')

  const statusListFiltered = statusList.filter(
    (status) => status !== task.status,
  )

  const taskStatusNumber = statusListFiltered.map((status) =>
    getStatusColorById(getStatusIdByName(status)),
  )

  function handleSwipe() {
    if (isTeco) return []

    const swipeActionsMidstream = [
      {
        color: theme.colors.moveTo,
        text: 'Move to',
        onPress: () => setIsChangeStartTimeModalOpen(true),
      },
      {
        color: taskStatusNumber[0],
        text: formatStatus(statusListFiltered[0]),
        onPress: () => handleChangeTaskStatus(statusListFiltered[0]),
      },
      {
        color: taskStatusNumber[1],
        text: formatStatus(statusListFiltered[1]),
        onPress: () => handleChangeTaskStatus(statusListFiltered[1]),
      },
    ]

    return swipeActionsMidstream
  }

  function handleChangeTaskStatus(status: string) {
    const shouldPopUpSapCommentsModal = status === 'completed' && hasCriticality

    if (shouldPopUpSapCommentsModal) {
      setIsSapCommentsModalOpen((state) => !state)

      return
    }

    patchTask({
      id: task.id,
      changes: { status },
    })
  }

  return (
    <>
      <SwipeableRow rightActions={handleSwipe()}>{children}</SwipeableRow>
      <ChangeStartTimeModal
        openModal={isChangeStartTimeModalOpen}
        tasks={[task]}
        onClose={() => setIsChangeStartTimeModalOpen(false)}
      />
      <SapCommentsModal
        openModal={isSapCommentsModalOpen}
        onClose={() => setIsSapCommentsModalOpen(false)}
        task={task}
      />
    </>
  )
})
